<script>
    /*
    	ServiceFieldsGroup4.svelte
        
        Social/Online - 6 fields

        Expandable/Collapsible and contains a predetermined set of DataFields
    */

    import { onMount } from 'svelte';
    import { FACEBOOK, TWITTER, OTHER_SOCIAL, GOOGLE_BUS_LINK, GOOGLE_RATING, GOOGLE_NUM_RATINGS } from '../../common/constants.js';
    // import { shallowArraysEqual } from '../../common/utils.js';

    // TCARE components
    import DataTextField from '../data-fields/DataTextField.svelte';
    import DataWebField from '../data-fields/DataWebField.svelte';
    import DataNumberField from '../data-fields/DataNumberField.svelte';
    import FieldGroupExpandBar from './FieldGroupExpandBar.svelte';

    // SMUI components

    // const FIELDS = [ FACEBOOK, TWITTER, OTHER_SOCIAL, GOOGLE_BUS_LINK, GOOGLE_RATING, GOOGLE_NUM_RATINGS ];
    const GROUP_TITLE = 'Social/Online Information';

    export let store;                   // store is a Service store - not just data!
    export let leftService;
    export let rightService;
    export let onCopyValue;
    export let isEditable;
    export let isOpen;
    export let showDiffs;               // bypass the strike-through and highlighting

    $: apiData = $store.apiData;
    $: isExpanded = isOpen;

    onMount(() => {
        // console.log('ServiceFieldsGroup4 onMount');
    })

    const toggleIsExpanded = () => {
        isExpanded = !isExpanded;
    }


    // TODO: could move these to common area
    const isFieldDiff = (propName) => {
        if (!leftService) return false;
        if (!rightService) return false;
        return leftService[propName] !== rightService[propName];
    }

</script>

<style>
    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="field-group">
    
    <FieldGroupExpandBar title={GROUP_TITLE} {isExpanded} {toggleIsExpanded} />

    {#if apiData && isExpanded}
        <div class="fields-area">

            <!-- left and right blocks in a fluid row -->
            <div class="flex-row ai-start fluid">

                <div class="flex-block w-49">

                    <DataWebField
                        bind:value={apiData[FACEBOOK]}
                        propName={FACEBOOK}
                        label={'Facebook'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(FACEBOOK)}
                        isNewDiff={isFieldDiff(FACEBOOK)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                    <DataWebField
                        bind:value={apiData[TWITTER]}
                        propName={TWITTER}
                        label={'Twitter'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(TWITTER)}
                        isNewDiff={isFieldDiff(TWITTER)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                    <DataWebField
                        bind:value={apiData[OTHER_SOCIAL]}
                        propName={OTHER_SOCIAL}
                        label={'Other social'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(OTHER_SOCIAL)}
                        isNewDiff={isFieldDiff(OTHER_SOCIAL)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                </div>

                <div class="flex-block w-49">

                    <DataWebField
                        bind:value={apiData[GOOGLE_BUS_LINK]}
                        propName={GOOGLE_BUS_LINK}
                        label={'Google'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(GOOGLE_BUS_LINK)}
                        isNewDiff={isFieldDiff(GOOGLE_BUS_LINK)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                    <DataNumberField
                        bind:value={apiData[GOOGLE_RATING]}
                        propName={GOOGLE_RATING}
                        label={'Google Rating'}
                        isFloat={true}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(GOOGLE_RATING)}
                        isNewDiff={isFieldDiff(GOOGLE_RATING)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                    <DataTextField
                        bind:value={apiData[GOOGLE_NUM_RATINGS]}
                        propName={GOOGLE_NUM_RATINGS}
                        label={'Num. Ratings'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(GOOGLE_NUM_RATINGS)}
                        isNewDiff={isFieldDiff(GOOGLE_NUM_RATINGS)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                </div>
            </div>      <!-- end flex-row -->
        </div>      <!-- end fields-area -->

    {/if}
</div>
